<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium" :class="isRTL ? 'ml-auto' : 'mr-auto'">
        {{ i18n('iam.userDetails.title') }}
      </h2>
    </div>
    <!-- BEGIN: Profile Info -->
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        style="width: 100%; height: 30vh"
        class="flex justify-center"
        v-if="loading"
      >
        <LoadingIcon icon="grid" color="#2D3748" style="width: 100px" />
      </div>
      <div v-if="record && !loading">
        <div
          class="flex flex-col lg:flex-row border-b border-gray-200 dark:border-dark-5 pb-5 -mx-5"
        >
          <div class="flex flex-1 px-5 items-center justify-center">
            <div class="ml-5 mr-5">
              <div
                class="sm:whitespace-normal font-medium text-lg flex items-center gap-2"
              >
                <UserIcon
                  class="w-6 h-6"
                  :style="
                    isRTL
                      ? 'transform: rotateY(180deg)'
                      : 'transform: rotateY(0deg)'
                  "
                />
                <span>{{ record.fullName }}</span>
              </div>
              <div
                class="truncate sm:whitespace-normal flex items-center gap-2 mt-3"
              >
                <PhoneIcon
                  class="w-6 h-6"
                  :style="
                    isRTL
                      ? 'transform: rotateY(180deg)'
                      : 'transform: rotateY(0deg)'
                  "
                />
                <span style="direction: ltr !important">
                  <a :href="`tel:${record.phoneNumber}`">{{
                    record.phoneNumber ? record.phoneNumber : 'ـــــ'
                  }}</a>
                </span>
              </div>
              <div
                class="sm:whitespace-normal font-medium text-lg flex items-center gap-2 mt-3"
              >
                <AwardIcon
                  class="w-6 h-6"
                  :style="
                    isRTL
                      ? 'transform: rotateY(180deg)'
                      : 'transform: rotateY(0deg)'
                  "
                />
                <span>{{ record.points }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="nav nav-tabs flex-col sm:flex-row justify-center lg:justify-start"
          role="tablist"
        >
          <a
            id="owners-tab"
            data-toggle="tab"
            data-target="#owners"
            href="javascript:;"
            class="py-4 sm:mr-8 active"
            role="tab"
            aria-controls="owners"
            aria-selected="true"
            @click="tab = 'owners'"
          >
            {{ i18n('iam.userDetails.owned') }}
          </a>
          <a
            id="members-tab"
            data-toggle="tab"
            data-target="#members"
            href="javascript:;"
            class="py-4 sm:mr-8"
            role="tab"
            aria-selected="false"
            @click="tab = 'members'"
          >
            {{ i18n('iam.userDetails.membered') }}
          </a>
        </div>
      </div>
    </div>
    <!-- END: Profile Info -->

    <div class="intro-y tab-content mt-5">
      <div
        id="owners"
        class="tab-pane active"
        role="tabpanel"
        aria-labelledby="owners-tab"
        v-if="tab == 'owners'"
      >
        <UnitsTab :id="id" type="owners" />
      </div>

      <div
        id="members"
        class="tab-pane active"
        role="tabpanel"
        aria-labelledby="members-tab"
        v-if="tab == 'members'"
      >
        <UnitsTab :id="id" type="members" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UnitsTab from '@/views/users/units-tab.vue'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    UnitsTab
  },
  computed: {
    ...mapGetters({
      isRTL: 'layout/isRTL',
      language: 'layout/currentLanguageCode',
      record: 'user/view/record',
      loading: 'user/view/loading'
    })
  },
  created() {
    document.title = this.i18n('routes.app') + ' | ' + this.i18n('routes.users')
  },
  data() {
    return {
      tab: 'owners'
    }
  },
  watch: {
    isRTL() {
      document.title =
        this.i18n('routes.app') + ' | ' + this.i18n('routes.users')
    }
  },
  async mounted() {
    await this.doFind(this.id)
  },
  methods: {
    ...mapActions({
      doFind: 'user/view/doFind',
      doRemoveOwned: 'user/view/doRemoveOwned',
      doRemoveMembered: 'user/view/doRemoveMembered'
    }),
    i18n(key, args) {
      return this.$t(key, args)
    }
  }
}
</script>
